// extracted by mini-css-extract-plugin
module.exports = {"root":"Chip_root__exI73","selected":"Chip_selected__25fUy"};